var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTable(_ref, svgRef) {
  var _ref2;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.757812,
    width: 70.7174,
    height: 70.7174,
    rx: 12.1927,
    fill: "#639FF0",
    style: (_ref2 = {
      fill: "#639FF0"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.3882 0.6235 0.9412)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1172 30.8568H52.1172M42.1172 30.8568V49.1901M42.1172 30.8568H32.1172M52.1172 30.8568V45.8568C52.1172 47.4284 52.1172 48.2134 51.6289 48.7018C51.1405 49.1901 50.3555 49.1901 48.7839 49.1901H42.1172M52.1172 30.8568V25.8568C52.1172 24.2851 52.1172 23.5001 51.6289 23.0118C51.1405 22.5234 50.3555 22.5234 48.7839 22.5234H25.4505C23.8789 22.5234 23.0939 22.5234 22.6055 23.0118C22.1172 23.5001 22.1172 24.2851 22.1172 25.8568V30.8568M52.1172 30.8568H22.1172M42.1172 49.1901H32.1172M22.1172 30.8568H32.1172M22.1172 30.8568V45.8568C22.1172 47.4284 22.1172 48.2134 22.6055 48.7018C23.0939 49.1901 23.8789 49.1901 25.4505 49.1901H32.1172M32.1172 30.8568V49.1901",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.19188ea9.svg";
export { ForwardRef as ReactComponent };